import { render } from "./SellFileForm.vue?vue&type=template&id=782a0316"
import script from "./SellFileForm.vue?vue&type=script&lang=js"
export * from "./SellFileForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/maskansazangolchin-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__